import html2canvas from "html2canvas-pro";
import jsPDF from "jspdf";
import { format } from "date-fns";

export async function exportScorecardPdf(element: HTMLElement, asin: string): Promise<void> {
  const originalWidth = element.style.width;
  const originalMaxWidth = element.style.maxWidth;
  try {
    element.classList.add("pdf-export-mode");
    element.style.width = "1200px";
    element.style.maxWidth = "none";
    void element.offsetHeight;
    const canvas = await html2canvas(element, {
      scale: 1.5,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
      windowWidth: 1200,
      windowHeight: element.scrollHeight,
      width: element.scrollWidth,
      height: element.scrollHeight,
    });
    if (canvas.width === 0 || canvas.height === 0) {
      throw new Error("Canvas is empty");
    }
    const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
    const pageWidthMm = pdf.internal.pageSize.getWidth();
    const pageHeightMm = pdf.internal.pageSize.getHeight();
    const pxPerMm = canvas.width / pageWidthMm;
    const pageHeightPx = Math.floor(pageHeightMm * pxPerMm);
    const dateStr = format(new Date(), "yyyy-MM-dd");
    let srcY = 0;
    let pageNum = 0;
    while (srcY < canvas.height) {
      const sliceHeightPx = Math.min(pageHeightPx, canvas.height - srcY);
      const sliceCanvas = document.createElement("canvas");
      sliceCanvas.width = canvas.width;
      sliceCanvas.height = sliceHeightPx;
      const ctx = sliceCanvas.getContext("2d");
      if (!ctx) throw new Error("Could not get canvas context");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
      ctx.drawImage(canvas, 0, -srcY);
      const sliceDataUrl = sliceCanvas.toDataURL("image/jpeg", 0.92);
      const sliceHeightMm = (sliceHeightPx / canvas.width) * pageWidthMm;
      if (pageNum > 0) pdf.addPage();
      pdf.addImage(sliceDataUrl, "JPEG", 0, 0, pageWidthMm, sliceHeightMm);
      srcY += pageHeightPx;
      pageNum += 1;
    }
    pdf.save(`amazon-ai-score-${asin}-${dateStr}.pdf`);
  } finally {
    element.style.width = originalWidth;
    element.style.maxWidth = originalMaxWidth;
    element.classList.remove("pdf-export-mode");
  }
}
